import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Configuração do Firebase
const firebaseConfig = {
  apiKey: "AIzaSyAxl6osKdputY1a5TxVw87Q2bvHuzae6U4",
  authDomain: "contratos-playkids.firebaseapp.com",
  projectId: "contratos-playkids",
  storageBucket: "contratos-playkids.firebasestorage.app",
  messagingSenderId: "745782435014",
  appId: "1:745782435014:web:28672c64ca269d8f6fcbc7",
  measurementId: "G-ZPY5S9701X"
};

// Inicializar Firebase
const app = initializeApp(firebaseConfig);

// Inicializar serviços
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;
